import type { ComponentProps } from 'react';
import { OwcSideMenu } from '@one/react';

export type PocSideMenuProps = ComponentProps<typeof OwcSideMenu>;

export const PocSideMenu: React.FC<PocSideMenuProps> = (props) => <OwcSideMenu {...props} />;
